export const ButtonState = Object.freeze({
    LOADING: 'loading',
    ERROR: 'error',
    SUCCESS: 'success',
    NORMAL: 'normal',
});